import React, { useState } from 'react';
import useTsrEnquirySubmit from '../hooks/useTsrEnquirySubmit';

function ContactEnquiryForm() {
	const [form, setForm] = useState({
		name: '',
		phone: '',
		email: '',
		eventType: '',
		eventDate: '',
		guestCount: '',
		message: '',
	});
	const { submitting, message, clearMessage, handleSubmit: submitEnquiry } = useTsrEnquirySubmit();

	const handleChange = (field) => (e) => {
		setForm((prev) => ({ ...prev, [field]: e.target.value }));
		clearMessage();
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const ok = await submitEnquiry({
			formType: 'ContactPage',
			name: form.name.trim(),
			phone: form.phone.trim(),
			email: form.email.trim(),
			eventType: form.eventType,
			eventDate: form.eventDate,
			guestCount: form.guestCount,
			message: form.message.trim(),
		});
		if (ok) {
			setForm({
				name: '',
				phone: '',
				email: '',
				eventType: '',
				eventDate: '',
				guestCount: '',
				message: '',
			});
		}
	};

	const feedbackClass = [
		'tsr-enquiry-feedback',
		message.type === 'success' ? 'tsr-enquiry-feedback--success' : '',
		message.type === 'error' ? 'tsr-enquiry-feedback--error' : '',
	]
		.filter(Boolean)
		.join(' ');

	return (
		<div className="mf-form-wrapper">
			<form className="metform-form-content" onSubmit={handleSubmit} noValidate>
				{message.text ? (
					<div role="alert" aria-live="polite" className={feedbackClass}>
						{message.text}
					</div>
				) : null}
				<div className="metform-form-main-wrapper">
					<div data-elementor-type="wp-post" data-elementor-id="1293" className="elementor elementor-1293">
						<section className="elementor-section elementor-top-section elementor-element elementor-element-7eca56f6 elementor-section-full_width" data-id="7eca56f6" data-element_type="section">
							<div className="elementor-container elementor-column-gap-default">
								<div className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-5539f7eb" data-id="5539f7eb" data-element_type="column">
									<div className="elementor-widget-wrap elementor-element-populated">
										<section className="elementor-section elementor-inner-section elementor-element elementor-element-5b469eeb elementor-section-full_width" data-id="5b469eeb" data-element_type="section">
											<div className="elementor-container elementor-column-gap-default">
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-40819b95" data-id="40819b95" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-4dc87cc4 elementor-widget elementor-widget-mf-text" data-id="4dc87cc4" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-text-4dc87cc4">Full Name</label>
																	<input
																		type="text"
																		className="mf-input"
																		id="mf-input-text-4dc87cc4"
																		name="mf-first-name"
																		placeholder="Enter your name here"
																		required
																		value={form.name}
																		onChange={handleChange('name')}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-3b7b6da2" data-id="3b7b6da2" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-b1d2ed1 elementor-widget elementor-widget-mf-telephone" data-id="b1d2ed1" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-telephone-b1d2ed1">Contact Number</label>
																	<input
																		type="tel"
																		className="mf-input"
																		id="mf-input-telephone-b1d2ed1"
																		name="mf-telephone"
																		placeholder="+91  8080888889"
																		required
																		value={form.phone}
																		onChange={handleChange('phone')}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</section>

										<section className="elementor-section elementor-inner-section elementor-element elementor-element-3a34f48 elementor-section-full_width" data-id="3a34f48" data-element_type="section">
											<div className="elementor-container elementor-column-gap-default">
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5b1958af" data-id="5b1958af" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-1a0e467e elementor-widget elementor-widget-mf-text" data-id="1a0e467e" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-email-1a0e467e">Email Address</label>
																	<input
																		type="email"
																		className="mf-input"
																		id="mf-input-email-1a0e467e"
																		name="mf-email"
																		placeholder="user@website.com"
																		value={form.email}
																		onChange={handleChange('email')}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-41b886a1" data-id="41b886a1" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-8cd0809 elementor-widget elementor-widget-mf-select" data-id="8cd0809" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-select-8cd0809">Type of Event</label>
																	<select
																		className="mf-input"
																		id="mf-input-select-8cd0809"
																		name="mf-select"
																		value={form.eventType}
																		onChange={handleChange('eventType')}
																	>
																		<option value="">eg.Wedding Events</option>
																		<option value="Wedding Events">Wedding Events</option>
																		<option value="Corporate Events">Corporate Events</option>
																		<option value="Catering Service">Catering Service</option>
																		<option value="Private Events">Private Events</option>
																		<option value="Theme based events">Theme based events</option>
																	</select>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</section>

										<section className="elementor-section elementor-inner-section elementor-element elementor-element-7790d60c elementor-section-full_width" data-id="7790d60c" data-element_type="section">
											<div className="elementor-container elementor-column-gap-default">
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-7ae5340f" data-id="7ae5340f" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-5068176 elementor-widget elementor-widget-mf-date" data-id="5068176" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-date-5068176">Date</label>
																	<input
																		type="date"
																		className="mf-input"
																		id="mf-input-date-5068176"
																		name="mf-date"
																		placeholder="Date"
																		value={form.eventDate}
																		onChange={handleChange('eventDate')}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
												<div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-42596a0e" data-id="42596a0e" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-f50e639 elementor-widget elementor-widget-mf-number" data-id="f50e639" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-number-f50e639">Number</label>
																	<input
																		type="number"
																		className="mf-input"
																		id="mf-input-number-f50e639"
																		name="mf-number"
																		placeholder="eg.20"
																		value={form.guestCount}
																		onChange={handleChange('guestCount')}
																	/>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</section>

										<section className="elementor-section elementor-inner-section elementor-element elementor-element-65239fef elementor-section-full_width" data-id="65239fef" data-element_type="section">
											<div className="elementor-container elementor-column-gap-default">
												<div className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-259e03ce" data-id="259e03ce" data-element_type="column">
													<div className="elementor-widget-wrap elementor-element-populated">
														<div className="elementor-element elementor-element-686e422a elementor-widget elementor-widget-mf-textarea" data-id="686e422a" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-input-wrapper">
																	<label className="mf-input-label" htmlFor="mf-input-textarea-686e422a">Questions</label>
																	<textarea
																		className="mf-input mf-textarea"
																		id="mf-input-textarea-686e422a"
																		name="mf-comment"
																		placeholder="Feel free to ask a question or simply leave a comment"
																		cols="30"
																		rows="10"
																		value={form.message}
																		onChange={handleChange('message')}
																	></textarea>
																</div>
															</div>
														</div>
														<div className="elementor-element elementor-element-12055d4e mf-btn--left elementor-widget__width-auto elementor-widget elementor-widget-mf-button" data-id="12055d4e" data-element_type="widget">
															<div className="elementor-widget-container">
																<div className="mf-btn-wraper">
																	<button type="submit" className="metform-btn metform-submit-btn" disabled={submitting}>
																		<span>{submitting ? 'Sending...' : 'Enquire'}</span>
																	</button>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										</section>
									</div>
								</div>
							</div>
						</section>
					</div>
				</div>
			</form>
		</div>
	);
}

export default ContactEnquiryForm;
